<template>
  <base-footer :links="links"></base-footer>
</template>

<script>
import es from '@/lang/es/public/footer-opensalud.json'
import en from '@/lang/en/public/footer-opensalud.json'
import pt from '@/lang/pt/public/footer-opensalud.json'
import BaseFooter from '../../base/BaseFooter.vue'
import { inMx } from '@/helpers/global.helpers'

export default {
  name: 'FooterOpensalud',
  components: {
    BaseFooter
  },
  i18n: {
    messages: {
      es,
      en,
      mx: es,
      pt
    }
  },
  data () {
    return {
      links: {
        firstColumn: [
          {
            text: this.$t('professional-conditions'),
            href: '/terminos-condiciones-profesional'
          },
          {
            text: this.$t('patient-conditions'),
            href: '/terminos-condiciones-paciente'
          },
          {
            text: this.$t('companies-telemedicine'),
            href: '/opensalud360/empresas'
          },
          {
            text: this.$t('contact'),
            href: '/contacto'
          }
        ],
        secondColumn: [
          {
            text: this.$t('legal-notice'),
            href: inMx ? '/aviso-legal-cookies' : '/aviso-legal'
          },
          {
            text: this.$t('cookies-policy'),
            href: '/politica-cookies',
            hide: inMx
          },
          {
            text: this.$t('privacy-policy'),
            href: '/politica-privacidad',
            hide: inMx
          },
          {
            text: this.$t('privacy-policy-professional'),
            href: '/politica-privacidad-profesional',
            hide: inMx
          },
          {
            text: this.$t('sgsi-policy'),
            href: '/politica-sgsi',
            hide: inMx
          }
        ]
      }
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/public/footers/FooterOpensalud.vue